// extracted by mini-css-extract-plugin
export default {"inputGroup":"register-page_inputGroup__tqpYa","registerBtn":"register-page_registerBtn__5XdwK"};